import { render, staticRenderFns } from "./ProductBusinessType.vue?vue&type=template&id=fdb50ab4&scoped=true&"
import script from "./ProductBusinessType.vue?vue&type=script&lang=js&"
export * from "./ProductBusinessType.vue?vue&type=script&lang=js&"
import style0 from "./ProductBusinessType.vue?vue&type=style&index=0&id=fdb50ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb50ab4",
  null
  
)

export default component.exports